// removed by extract-text-webpack-plugin
module.exports = {"filterBarChannel":"filterBarChannel__F8W54VyA","active":"active__3zBa6Op8","dropdown":"dropdown__3AYMqmMg","icon":"icon__3WhHQ0IH","name":"name__vw86WICt","dropdownOffset":"dropdownOffset__1MDxJhb8","item":"item__dQt3RceK"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OYFilterBar/components/OYFilterBarChannel/index.module.less
// module id = 726
// module chunks = 1